import React, { useEffect, useRef, useState } from "react";
import { Container, Nav, Navbar } from "react-bootstrap";
import { useTranslation } from "react-i18next";

import { Link } from "react-router-dom";
import i18n from "i18next";

const Header = ({ showMenuItems }) => {
  const { t } = useTranslation();
  const [isMenuOpen, setMenuOpen] = useState(false);
  const menuRef = useRef(null);
  const toggleRef = useRef(null);

  const toggleLanguage = (e) => {
    e.preventDefault();
    const newLang = i18n.language.startsWith("pt") ? "en" : "pt";
    i18n.changeLanguage(newLang);
  };
  const isPT = i18n.language.startsWith("pt");

  const handleToggle = () => {
    setMenuOpen(!isMenuOpen);
  };

  const handleClickOutside = (event) => {
    if (
      isMenuOpen &&
      toggleRef.current &&
      !toggleRef.current.contains(event.target)
    ) {
      toggleRef.current.click();
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isMenuOpen]);

  return (
    <header>
      <Navbar expand="lg">
        <Container>
          <Navbar.Brand as={Link} to="/">
            <img
              src={require("img/logo_white.png")}
              alt="logotipo da aplicação iCyclin"
              width="auto"
              height="30"
              className="d-inline-block align-top me-2"
            />
          </Navbar.Brand>
          <Navbar.Toggle
            aria-controls="app-navbar"
            ref={toggleRef}
            onClick={handleToggle}
          />
          <Navbar.Collapse id="app-navbar" ref={menuRef}>
            <Nav className="me-auto">
              <Nav.Link as={Link} to="/private/search">
                <img
                  src={require("img/icons/Icone_Interacoes_Farmaco.png")}
                  alt=""
                />
                {t("auto.interacoesPorFarmaco", "Interações por fármaco")}
              </Nav.Link>
              <Nav.Link as={Link} to="/private/groups">
                <img
                  src={require("img/icons/Icone_Grupos_Farmacologicos.png")}
                  alt=""
                />
                {t("auto.gruposFarmacologicos", "Grupos farmacológicos")}
              </Nav.Link>
              <Nav.Link as={Link} to="/private/patient">
                <img
                  src={require("img/icons/Icone_Perfil_Doente.png")}
                  alt=""
                />
                {t("auto.perfilDeDoente", "Perfil de doente")}
              </Nav.Link>
            </Nav>
            <Nav>
              <Nav.Link as={Link} to="/help">
                <img
                  src={require("img/icons/Icone_Como_Funciona.png")}
                  alt=""
                />
                {t("auto.comoFunciona", "Como funciona")}
              </Nav.Link>
              <Nav.Link as={Link} to="/private/references">
                <img
                  src={require("img/icons/Icone_Referencias_Bibliograficas.png")}
                  alt=""
                />
                {t("auto.referencias", "Referências")}
              </Nav.Link>
              <Nav.Link as={Link} to="/about">
                <img src={require("img/icons/Icone_Sobre_a_SPS.png")} alt="" />
                {t("auto.sobre", "Sobre")}
              </Nav.Link>
              <a
                className="nav-link"
                href="#"
                onClick={toggleLanguage}
                style={{ cursor: "pointer" }}
              >
                <img
                  src={require("img/icons/Icone_Language_Switch.png")}
                  alt=""
                />
                <span>
                  <span style={{ fontWeight: !isPT ? "bold" : "normal" }}>
                    EN
                  </span>
                  {" | "}
                  <span style={{ fontWeight: isPT ? "bold" : "normal" }}>
                    PT
                  </span>
                </span>
              </a>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </header>
  );
};

export default Header;
